<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/xihoumenFreshAirIndex">首页</el-menu-item>
        
        <el-menu-item index="/xihoumenFreshAir/gasClamp">全桥新风</el-menu-item>
        <el-menu-item index="/xihoumenFreshAir/steelbox">箱梁新风</el-menu-item>

        <el-menu-item index="/xihoumenFreshAir/currentDataTable?bridgeId=c6c66f8a-3738-4cfa-91b0-c4e18de7ff71">实时数据表</el-menu-item>
        <el-menu-item index="/xihoumenFreshAir/errorRecord?bridgeId=c6c66f8a-3738-4cfa-91b0-c4e18de7ff71">报警记录</el-menu-item>
        <el-submenu :index="'/xihoumenFreshAir/dataHistory?bridgeId=c6c66f8a-3738-4cfa-91b0-c4e18de7ff71&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/xihoumenFreshAir/dataHistory?bridgeId=c6c66f8a-3738-4cfa-91b0-c4e18de7ff71&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/xihoumenFreshAir/dataHistory?bridgeId=c6c66f8a-3738-4cfa-91b0-c4e18de7ff71"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="ZHOUSHAN" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main xi-hou-men">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
    <script>
export default {
  name: "xihoumenFreshAir",
  data() {
    return {
      bridgeId: "c6c66f8a-3738-4cfa-91b0-c4e18de7ff71",
      envInfo: {
        envId: "8567095f-76f3-45a8-8374-f0cd3430e5a4",
        weather: "7912f7b4-2548-4a41-a359-a0303d01a2f8",
        humidity: "c35a57a7-559f-4359-aa73-58dcb5e4d59d",
        temperature: "0bb178de-897c-4339-8fd5-b7e00be04db2",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>
    
    <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>